import {
  routeTraceProgress,
  spotTraceCheckpointReady,
  type RouteTraceState,
  type SpotTraceCheckpoint,
  type SpotTraceState,
} from "./route-trace.ts";

export type PublishBlockerKey = "title" | "route" | "settings" | "spots" | "spotFields";

export function routePublishBlockers(q: RouteTraceState): PublishBlockerKey[] {
  const p = routeTraceProgress(q);
  const keys: PublishBlockerKey[] = [];
  if (!p.route) keys.push("route");
  if (!p.settings) keys.push("settings");
  if (!p.title) keys.push("title");
  return keys;
}

export function spotPublishBlockers(q: SpotTraceState): PublishBlockerKey[] {
  const keys: PublishBlockerKey[] = [];
  if (!q.title?.trim()) keys.push("title");
  if (q.checkpoints.length < 1) keys.push("spots");
  else if (!q.checkpoints.every((s) => spotTraceCheckpointReady(s as SpotTraceCheckpoint))) keys.push("spotFields");
  return keys;
}
